<template>
    <span class="badge-total">
        <span
            v-if="label"
            class="badge-title"
        >
            {{ label }}
        </span>
        <span
            :class="'bg-' + getColor(color)"
            :title="title"
            class="label"
        >
            {{ getValue() }}
        </span>
    </span>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
        convertNegative: {
            type: Boolean,
            default: false,
        },
        symbol: {
            type: String,
            default: '',
        },
    },
    computed: {
        valueNumber: function () {
            return typeof this.value === 'string' ? Number(this.value.replace(/\s/g, '')) : this.value;
        },
    },
    methods: {
        getColor(color) {
            return this.convertNegative && this.valueNumber < 0 ? 'red' : color;
        },
        getValue() {
            return this.convertNegative ? this.symbol + String(this.value).replace('-', '') : this.value;
        },
    },
};
</script>
